import { z } from 'zod';
import { concurrencySchema, idSchema, isoDateTimeSchema, positionSchema, prioritySchema } from './common.js';
export const createCardSchema = z.object({
    title: z.string().min(1, 'Titel ist Pflicht').max(200),
    description: z.string().max(20000).optional(),
    dueAt: isoDateTimeSchema.nullable().optional(),
    /** Gehoert zur Faelligkeit eine Uhrzeit? Ohne Datum bedeutungslos. */
    dueHasTime: z.boolean().optional(),
    startAt: isoDateTimeSchema.nullable().optional(),
    priority: prioritySchema.optional(),
    assigneeIds: z.array(idSchema).max(10).optional(),
    /** Einfuegeposition: nach welcher Karte? `null` = an den Anfang. */
    afterCardId: idSchema.nullable().optional(),
});
export const patchCardSchema = concurrencySchema
    .extend({
    title: z.string().min(1).max(200).optional(),
    description: z.string().max(20000).nullable().optional(),
    dueAt: isoDateTimeSchema.nullable().optional(),
    dueHasTime: z.boolean().optional(),
    startAt: isoDateTimeSchema.nullable().optional(),
    priority: prioritySchema.optional(),
    completed: z.boolean().optional(),
    /** Nur die anlegende Person darf das setzen (SPEC-Ergaenzung "Privat"). */
    isPrivate: z.boolean().optional(),
})
    .refine((v) => Object.keys(v).some((k) => k !== 'updatedAt'), {
    message: 'Keine Aenderung angegeben',
});
/**
 * Move ist ein eigener, idempotenter Endpoint (SPEC 6 und 7.2) und bewusst von
 * der 409-Logik ausgenommen: sonst waere paralleles Verschieben unbrauchbar.
 * Der Client darf den Fractional Key direkt setzen (er kennt die Nachbarn aus
 * dem gerenderten Board) oder die Nachbarkarte benennen.
 */
export const moveCardSchema = z.object({
    columnId: idSchema,
    position: positionSchema.optional(),
    /**
     * `null` = an den Anfang der Spalte, eine ID = direkt dahinter,
     * weggelassen = ans Ende. Ohne `position` berechnet der Server den Key.
     */
    afterCardId: idSchema.nullable().optional(),
});
export const assigneeSchema = z.object({ userId: idSchema });
/**
 * Board-zu-Board (SPEC-Ergaenzung): eigener, einfacher Endpoint statt einer
 * Erweiterung von `moveCardSchema` — hier gelten andere Regeln (Ziel-Board
 * statt Ziel-Spalte im selben Board, keine client-seitige Positionsangabe,
 * weil Labels/Verantwortliche beim Wechsel sowieso neu berechnet werden).
 */
export const moveCardToBoardSchema = z.object({
    boardId: idSchema,
    columnId: idSchema,
});
export const cardLabelSchema = z.object({ labelId: idSchema });
export const createChecklistItemSchema = z.object({
    text: z.string().min(1, 'Text ist Pflicht').max(300),
    afterItemId: idSchema.nullable().optional(),
});
export const patchChecklistItemSchema = z
    .object({
    text: z.string().min(1).max(300).optional(),
    isDone: z.boolean().optional(),
    afterItemId: idSchema.nullable().optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'Keine Aenderung angegeben' });
//# sourceMappingURL=card.js.map